
import { defineComponent, ref, toRefs, reactive } from "vue";
import Datepicker from "vue3-datepicker";
import { Event, OriginTags } from "@/interfaces/Event";
import { truncate } from "@/helpers/helpers";
import { formatTime, timeNowAsJS, jsTimeToRealEpoch, getNextDayFromDate } from "@/helpers/time";
import { fetchOrigins, fetchEvents } from "@/helpers/api";
import { EventOrigin } from "@/interfaces/EventOrigin";
import { Temporal } from "@js-temporal/polyfill";
import { getDateFormat } from "@/helpers/store";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default defineComponent({
  components: {
    Datepicker,
    LoadingSpinner,
  },
  name: "EventsPage",
  setup() {
    const state = reactive({
      events: [] as Event[],
      filters: {
        origin: {} as OriginTags,
      },
      origins: [] as EventOrigin[],
      pickerStartDate: ref(timeNowAsJS(-1)),
      pickerEndDate: ref(timeNowAsJS()),
      dateFormat: getDateFormat(),
      isLoading: true,
      firstLoad: true,
    });

    const load_origins = async () => {
      const origins = await fetchOrigins();
      state.origins = origins.filter((origin) => origin.Site && origin.Aggregator);
    };

    const get_events = async () => {
      state.isLoading = true;
      let params = new URLSearchParams();
      params.set("Limit", "100");
      if (state.firstLoad === false) {
        if (state.pickerStartDate) {
          params.set("StartTime", jsTimeToRealEpoch(state.pickerStartDate));
        }
        if (state.pickerEndDate) {
          params.set("EndTime", jsTimeToRealEpoch(state.pickerEndDate));
        }
      }
      if (state.filters.origin) {
        if (state.filters.origin.Site) {
          params.set("OriginTags.Site", state.filters.origin.Site);
        }
        if (state.filters.origin.Aggregator) {
          params.set("OriginTags.Aggregator", state.filters.origin.Aggregator);
        }
      }

      state.events = await fetchEvents(params);
      state.isLoading = false;
      state.firstLoad = false;
    };

    const push_end_date = () => {
      if (state.pickerEndDate) {
        if (state.pickerStartDate > state.pickerEndDate) {
          state.pickerEndDate = getNextDayFromDate(state.pickerStartDate);
        }
      }
    };

    load_origins();
    get_events();

    return {
      ...toRefs(state),
      truncate,
      formatTime,
      get_events,
      push_end_date,
      Temporal,
    };
  },
});
